/** @format */

import { takeLatest } from "redux-saga/effects";
import { TActionType } from "../declarations/actionTypes";
import { sagaRoleList } from "../sagas/sagasRole";

export function* watcherRole(): unknown {
  yield takeLatest(TActionType.roleListRequest, sagaRoleList);
}
